import { en } from '../locales/en_US';

export const enLang = {
  messages: {
    ...en,
  },
  locale: 'en-US',
};



// WEBPACK FOOTER //
// ./src/lang/entries/en-US.js